import {useEffect} from "react";

const useHideSidebar = () => {
    useEffect(() => {
        document.documentElement.classList.remove('has-aside-left', 'has-navbar-fixed-top');
        return () => document.documentElement.classList.add('has-aside-left', 'has-navbar-fixed-top');
    }, []);
};

export default useHideSidebar;